import * as tslib_1 from "tslib";
import { MatDialog } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { LocationSectorApi } from '../../../../../../../../core/api/location-sectors/location-sectors.api';
import { ArchiveSectorDialogService } from '../../../../../../../../core/components/archive-sector-dialog/archive-sector-dialog.service';
import { ActionTypeEnum } from '../../../../../../../../core/components/fc-tree-view/fc-tree.types';
import { fetchAllInBatches } from '../../../../../../../../core/utils/fetch-all-in-batches';
import { LinkEquipmentDialogService } from '../../../../../dialog-link-equipment/dialog-link-equipment.service';
import { DialogLocationSectorComponent } from '../../../../../dialog-location-sector/dialog-location-sector.component';
import { EquipmentLinkService } from '../equipment/equipment.service';
import { LocationLinkEnvironmentService } from '../location-environment/location-environment.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../core/api/location-sectors/location-sectors.api";
import * as i2 from "@angular/material/dialog";
import * as i3 from "@ngx-translate/core";
import * as i4 from "../location-environment/location-environment.service";
import * as i5 from "../equipment/equipment.service";
import * as i6 from "../../../../../../../../core/components/archive-sector-dialog/archive-sector-dialog.service";
import * as i7 from "../../../../../dialog-link-equipment/dialog-link-equipment.service";
var LocationLinkSectorService = /** @class */ (function () {
    function LocationLinkSectorService(locationSectorApi, matDialog, translateService, locationLinkEnvironmentService, equipmentLinkService, archiveSectorDialogService, linkEquipmentDialogService) {
        this.locationSectorApi = locationSectorApi;
        this.matDialog = matDialog;
        this.translateService = translateService;
        this.locationLinkEnvironmentService = locationLinkEnvironmentService;
        this.equipmentLinkService = equipmentLinkService;
        this.archiveSectorDialogService = archiveSectorDialogService;
        this.linkEquipmentDialogService = linkEquipmentDialogService;
    }
    LocationLinkSectorService.prototype.searchLocationSectors = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, fetchAllInBatches(this.locationSectorApi, params)];
            });
        });
    };
    LocationLinkSectorService.prototype.formatSectors = function (sectors) {
        var _this = this;
        return sectors.map(function (sector) {
            var sectorItem = {
                id: sector.id,
                text: sector.name,
                description: sector.description,
                searchTerm: [sector.name, sector.description].filter(Boolean).join(' ').toLowerCase(),
                archived: sector.archived,
                archivedText: _this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.ARCHIVED'),
                icon: 'sector',
                metadata: 'sector',
                action: {
                    type: ActionTypeEnum.menu,
                    buttons: _this.sectorsButtons(sector)
                }
            };
            var environments = _this.locationLinkEnvironmentService.formatEnvironments(sector.locationEnvironments, sectorItem);
            var equipments = _this.equipmentLinkService.formatEquipments(sector.equipments, sectorItem);
            sectorItem.children = tslib_1.__spread(environments, equipments);
            return sectorItem;
        });
    };
    LocationLinkSectorService.prototype.sectorsButtons = function (locationSector) {
        var _this = this;
        var color = '#676767';
        return [
            {
                text: this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.EDIT_SECTOR'),
                icon: 'edit',
                color: color,
                action: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.openEditLocationSectorDialog({
                                    locationSectorId: locationSector.id
                                })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }
            },
            {
                text: this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.CREATE_ENVIRONMENT'),
                icon: 'environment_outline',
                color: color,
                action: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.locationLinkEnvironmentService.openCreateLocationEnvironmentDialog({
                                    location: locationSector.location,
                                    locationSectorId: locationSector.id
                                })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }
            },
            {
                text: this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.LINK_EQUIPMENT'),
                icon: 'equipment',
                color: color,
                action: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.openLinkEquipmentDialog({
                                    locationSector: locationSector
                                })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }
            },
            {
                text: locationSector.archived
                    ? this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.UNARCHIVE_SECTOR_TITLE')
                    : this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.ARCHIVE_SECTOR_TITLE'),
                icon: locationSector.archived ? 'unarchive_outline' : 'archive_outline',
                color: color,
                action: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.openArchiveOrUnarchiveLocationSectorDialog({
                                    locationSector: locationSector
                                })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }
            },
        ];
    };
    LocationLinkSectorService.prototype.openCreateLocationSectorDialog = function (_a) {
        var location = _a.location;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.openLocationSectorDialog({ location: location })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LocationLinkSectorService.prototype.openEditLocationSectorDialog = function (_a) {
        var locationSectorId = _a.locationSectorId;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.openLocationSectorDialog({ locationSectorId: locationSectorId })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LocationLinkSectorService.prototype.openLocationSectorDialog = function (_a) {
        var locationSectorId = _a.locationSectorId, location = _a.location;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var locationSector, _b, result;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!locationSectorId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.locationSectorApi.get(locationSectorId)];
                    case 1:
                        _b = _c.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _b = {
                            id: null,
                            name: '',
                            description: '',
                            location: location
                        };
                        _c.label = 3;
                    case 3:
                        locationSector = _b;
                        return [4 /*yield*/, this.matDialog
                                .open(DialogLocationSectorComponent, {
                                panelClass: 'dialog-location-sector',
                                data: {
                                    locationSector: locationSector
                                }
                            })
                                .afterClosed()
                                .toPromise()];
                    case 4:
                        result = _c.sent();
                        if (result && result.reload) {
                            window.emitEvent('location-links::reload-tree-view');
                            return [2 /*return*/, result];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LocationLinkSectorService.prototype.openArchiveOrUnarchiveLocationSectorDialog = function (_a) {
        var locationSector = _a.locationSector;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.archiveSectorDialogService.open({
                            sectorId: locationSector.id,
                            archived: locationSector.archived,
                            name: locationSector.name
                        })];
                    case 1:
                        result = _b.sent();
                        if (!result || !result.reload) {
                            return [2 /*return*/];
                        }
                        window.emitEvent('location-links::reload-tree-view');
                        return [2 /*return*/];
                }
            });
        });
    };
    LocationLinkSectorService.prototype.openLinkEquipmentDialog = function (_a) {
        var locationSector = _a.locationSector;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.linkEquipmentDialogService.open({
                            locationId: locationSector.location.id,
                            locationSectorId: locationSector.id,
                            locationEnvironmentId: null,
                        })];
                    case 1:
                        result = _b.sent();
                        if (!result || !result.reload) {
                            return [2 /*return*/];
                        }
                        window.emitEvent('location-links::reload-tree-view');
                        return [2 /*return*/];
                }
            });
        });
    };
    LocationLinkSectorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LocationLinkSectorService_Factory() { return new LocationLinkSectorService(i0.ɵɵinject(i1.LocationSectorApi), i0.ɵɵinject(i2.MatDialog), i0.ɵɵinject(i3.TranslateService), i0.ɵɵinject(i4.LocationLinkEnvironmentService), i0.ɵɵinject(i5.EquipmentLinkService), i0.ɵɵinject(i6.ArchiveSectorDialogService), i0.ɵɵinject(i7.LinkEquipmentDialogService)); }, token: LocationLinkSectorService, providedIn: "root" });
    return LocationLinkSectorService;
}());
export { LocationLinkSectorService };
